<template>
  <div class="row spinner-parent">
    <div class="col-12">
      <div class="card">
        <div class="card-header">
          <h1>Edit memory image</h1>
        </div>
      </div>

      <div class="card">
        <div class="card-header">
          <strong>General</strong>
        </div>
        <div class="card-body form-horizontal">
          <div class="row">
            <div class="col-12">
              <div class="card-block spinner-parent">
                <spinner ref="spinner" size="md" text="Loading ..." />

                <div class="form-group row">
                  <label for="title" class="col-md-2">Title *</label>
                  <div class="col-md-10">
                    <input
                      id="title"
                      v-model="entity.title"
                      type="text"
                      placeholder="Enter title"
                      class="form-control"
                    >
                  </div>
                </div>
                <div class="form-group row">
                  <label class="col-md-2" for="default">Type *</label>
                  <div class="col-md-10">
                    <select id="default" v-model="entity.is_person" class="form-control">
                      <option v-for="(type, idx) in personTypes" :key="idx" :value="type.isPerson">
                        {{ type.text }}
                      </option>
                    </select>
                  </div>
                </div>
                <div class="form-group row">
                  <label for="bio" class="col-md-2">Image *</label>
                  <div class="col-md-10">
                    <image-uploader
                      ref="uploader"
                      :uploaded-img-url="source.image ? source.image.public_url : null"
                      :removable="false"
                      @changeFile="coverChange"
                    />
                  </div>
                </div>

                <div class="form-group row">
                  <label for="title" class="col-md-2">Reference Image</label>
                  <div class="col-md-10">
                    <v-select :options="images" label="title" id="default" v-model="selected_ref_id"  class="v-select-game" :class="vsGame" :placeholder="entity.reference.title">
                      <template slot="option" slot-scope="option">
                          <img :src="option.thumbnail">
                          <span v-if="option.title">{{ option.title }}</span>
                      </template>
                    </v-select>
                  </div>
                </div>
              
                <template v-for="(quote, key) in entity.quotes">
                  <MemoryQuote
                    :key="key"
                    :quote="quote"
                    :number="key"
                    @deleteQuote="onDeleteQuote"
                  />
                </template>
      
                <button class="btn btn-success" @click="addQuote">
                  Add Quote
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="mb-5">
        <button class="btn btn-success" @click="save">
          Save
          <span class="btn-loader" style="display: none;" />
        </button>

        <div class="saving-alerts" style="margin-top: 20px;">
          <div class="alert alert-success" style="display: none;">
            Memory image has added successful!
          </div>
          <div class="alert alert-danger" style="display: none;">
            {{ saveErrorMessage }}
          </div>
        </div>
      </div>
    </div>
  </div><!--/.row-->
</template>

<script>
import _ from 'lodash';
// Mixins
import CreatePageMixin from '@/mixins/CreatePageMixin';
import DefaultOptionsRequests from '@/mixins/DefaultOptionsRequests';
import MemoryGameMixin from '@/mixins/MemoryGameMixin';
import MemoryQuote from './MemoryQuote.vue';

export default {
  name: 'MemoryImageEdit',

  components: {
    MemoryQuote,
  },

  mixins: [CreatePageMixin, DefaultOptionsRequests, MemoryGameMixin],

  mounted() {
    this.getSource();
  },

  data () {
    return{
      selected_ref_id: {},
      entity: {
        reference: {
          title: ''
        }
      }
    }
  },

  computed: {
    vsGame() {
      return {
        'display-selected-tag': this.selected_ref_id.title != '' && this.selected_ref_id.title != undefined,
        'hide-selected-tag': this.selected_ref_id.title == undefined
      }
    }
  },
  
  methods: {
    isEntityValid() {
      const filelds = [
        { name: 'Title', value: this.entity.title, type: 'required' },
      ];
      return this.$_validate(filelds);
    },
    saveRequest() {
      const postFormData = new FormData();
      postFormData.append('title', this.entity.title);
      postFormData.append('quotes', JSON.stringify(this.entity.quotes));
      postFormData.append('is_person', this.entity.is_person ? 1 : 0);
      if (this.selected_ref_id.id) {
        postFormData.append('ref_id', this.selected_ref_id.id);
      } else {
        postFormData.append('ref_id', this.entity.ref_id);
      }
      if (this.entity.memory_image) {
        this.saveImage();
      }
      return this.$apiHttp.post(`${this.$config.app_api.prefix}games/memory/${this.$route.params.id}`, postFormData);
    },
    save() {
      $('.saving-alerts .alert').hide();
      $('.btn-success .btn-loader').show();
      if (!this.isEntityValid()) return;
      this.saveRequest().then(() => {
        this.$_successSave();
        this.$parent.getSource();
      }, (error) => {
        console.error('Error in audio create request', error);
        this.$_errorSave(error);
      });
    },
    saveImage() {
      const postFormData = new FormData();
      postFormData.append('media_image', this.entity.memory_image);
      return this.$apiHttp.post(
        `${this.$config.app_api.prefix}games/memory/${this.$route.params.id}/image`,
        postFormData,
      );
    },
    coverChange(file) {
      this.imageLoaded = false;
      this.$_coverChange(file);
      if (!this.imageOnLoadHandlerSet) {
        this.$refs.uploader.$refs.imageBoxImg.onload = () => {
          this.imageLoaded = true;
        };
        this.imageOnLoadHandlerSet = true;
      }
      if (file) {
        this.imageSelected = true;
        this.entity.memory_image = file;
        return;
      }
      this.imageSelected = false;
    },
    getSource() {
      if (this.$refs.spinner) { this.$refs.spinner.show(); }
      const formData = new FormData();
      formData.append('with[]', 'image');
      this.$apiHttp.get(`${this.$config.app_api.prefix}games/memory/${this.$route.params.id}`)
        .then((response) => {
          const source = _.cloneDeep(response.data);
          const clone = _.cloneDeep(source);
          this.source = source;
          this.entity = clone;
          if (this.entity.reference == undefined) {
            this.entity.reference = {};
            this.entity.reference.quotes = [];
          };
          if (this.entity.quotes == null) {
            this.entity.quotes = [];
          }
          if (this.entity.ref_id == null) {
            this.entity.reference.title = 'No image chosen ...'
          };
          if (!this.images.length) {
            return this.getAllImages();
          }        
          if (this.$refs.spinner) { this.$refs.spinner.hide(); }
          return null;
        })
        .then((response) => {
          if (!response) {
            return;
          }
          const memoryImages = _.cloneDeep(response.data);
          delete memoryImages.meta;
          const images = Object.keys(memoryImages).map(e => memoryImages[e]);
          this.$store.dispatch('memoryGame/setImages', images);
          if (this.$refs.spinner) { this.$refs.spinner.hide(); }
        })
        .catch((error) => {
          if (this.$refs.spinner) { this.$refs.spinner.hide(); }
          this.$store.dispatch('notifications/setHttpError', { error, text: 'Error in getting puzzle image request' });
          console.error('Error in get single document files query', error);
        });
    },
    getAllImages() {
      return this.$apiHttp.get(`${this.$config.app_api.prefix}games/memory`, {
        params: {
          nonpaginated: true,
        },
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// Edit.vue?550b523a